import React from "react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";

const Text = styled.h1`
  font-family: Montserrat, serif;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  color: #1f2021;
`;

const HeadLine = ({ headingText, tagLine }) => {
  return (
    <>
      <Text>{headingText}</Text>
      {tagLine && <p>{tagLine}</p>}
    </>
  );
};

HeadLine.propTypes = {
  headingText: PropTypes.string.isRequired,
  tagLine: PropTypes.string,
};

export { HeadLine };
